import { useMutation, useQueryClient } from '@tanstack/react-query';
import { authFetch } from '../utils/authFetch';
import { API_URL } from '../config/api';
import { DisbursementRule } from '../types';

interface CreateDisbursementRuleInput {
  category: number;
  percentage: number;
  destination_account_ids: number[];
}

export function useCreateDisbursementRule() {
  const queryClient = useQueryClient();
  return useMutation<DisbursementRule, Error, CreateDisbursementRuleInput>({
    mutationFn: async (data) => {
      const response = await authFetch(`${API_URL}/disbursement-rules/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      if (!response.ok) throw new Error('Failed to create disbursement rule');
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['disbursementRules'] });
    },
  });
} 